import { reorderSubCategoriesMutation } from '../../../lib/graphql';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

// Category Studio (A2): persist drag & drop ordering of subcategories within a category.
const reorderSubCategories = (categoryId, orderedIds) => {
    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation: reorderSubCategoriesMutation,
                variables: { categoryId, orderedIds },
            });

            if (data?.reorderSubCategories?.status === 200) {
                return { status: 200 };
            }
            showToaster({ messageId: 'errorMessage', requestContent: data?.reorderSubCategories?.errorMessage, toasterType: 'error' });
            return { status: 400 };
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
            return { status: 400 };
        }
    };
};

export default reorderSubCategories;
